"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _animatedarrowModule = _interopRequireDefault(require("./css/animatedarrow.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AnimatedArrow = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${_animatedarrowModule.default["arrow-container"]}`
  });
};
var _default = exports.default = AnimatedArrow;